// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d65afec","455":"c31109cb","977":"4cd83585"}[chunkId] + ".chunk.js";
};